import axios from 'axios'
import Model from '../model'
import Regular from './regular'
import PaymentFiles from './PaymentFiles.js'
import notification from 'element-ui/packages/notification'


export default class Payment extends Model {
  constructor(props) {
    super(props);
    this._form.document = '';
    this._form.certificate = '';
    this._form.certificateName = '';
    this._form.nds = 0;
    this._form.OnlineCashId = 0;
    this._form.BillProvideTypeId = 1;
    this._form.showNds = false;
    this.additionalValues = [];
    this._form.date = props.date || new Date().toStringRu();
    this.addCashCheck = false;
    this.none = false;
    this._text = {
      createManager: '',
      createSystem: '',
      createDate: '',
    };
    this.regular = new Regular(this);
    this.files = new PaymentFiles(this);
    this.$props = {
      action: props.action,
      id: props.id,
      date: props.date ? props.date : '',
    }
  }

  init() {
    const self = this;
    return new Promise((resolve, reject) => {
      self.loading = true;
      self
        .getCatalogData()
        .then(async () => {
          self.currency = self.currencyMain;
          switch (self.$props.action) {
            case 'add':
              await self.initAdd();
              break;
            case 'order':
              await self.initAgreement();
              break;
            case 'regular':
              await self.initRegular();
              break;
            case 'bonus':
              await self.initBonus();
              break;
            case 'edit':
              await self.initEdit();
          }
          // if (self.$props.edit) {
          //
          // } else {
          //   let type;
          //   switch (self.$props.action) {
          //     case 'add':
          //       await self.initAdd();
          //       resolve(self);
          //       break;
          //   }
          // }
          self.loading = false;
          resolve(self);
        }, reject)
    });
  }

  initAdd() {
    const self = this;
    return new Promise((resolve, reject) => {
      const type = self.dictionary.types.find(i => i.id === self.catalogData.DefaultPaymentType);
      let cash = self.dictionary.cashes.find(i => i.id === self.catalogData.DefaultPaymentSource);
      if (!cash) cash = self.dictionary.cashes[0];
      let account = self.dictionary.accounts.find(i => i.id === self.catalogData.DefaultPaymentSource);
      if (!account) account = self.dictionary.accounts[0];
      self.direction = self.catalogData.DefaultPaymentDirection;
      self.operation = self.catalogData.DefaultPaymentOperation;
      self.category = type ? type.category : 0;
      self.type = self.catalogData.DefaultPaymentType;
      self.cash = cash ? cash.value : '';
      self.account = account ? account.value : '';
      resolve()
    });
  }

  initAgreement() {
    const self = this;
    return new Promise((resolve, reject) => {
      const type = self.dictionary.types.find(i => i.id === self.catalogData.DefaultAgreementPaymentType);
      let cash = self.dictionary.cashes.find(i => i.id === self.catalogData.DefaultAgreementPaymentSource);
      if (!cash) cash = self.dictionary.cashes[0];
      let account = self.dictionary.accounts.find(i => i.id === self.catalogData.DefaultAgreementPaymentSource);
      if (!account) account = self.dictionary.accounts[0];
      self.direction = self.catalogData.DefaultAgreementPaymentDirection;
      self.operation = self.catalogData.DefaultAgreementPaymentOperation;
      self.category = type ? type.category : 0;
      self.type = self.catalogData.DefaultAgreementPaymentType;
      self.cash = cash ? cash.value : '';
      self.account = account ? account.value : '';
      self.agreementAdd(self.$props.id).then(resolve, reject);
    });
  }

  initRegular() {
    const self = this;
    return new Promise((resolve, reject) => {
      const type = self.dictionary.types.find(i => i.id === self.catalogData.DefaultPaymentType);
      let cash = self.dictionary.cashes.find(i => i.id === self.catalogData.DefaultPaymentSource);
      if (!cash) cash = self.dictionary.cashes[0];
      let account = self.dictionary.accounts.find(i => i.id === self.catalogData.DefaultPaymentSource);
      if (!account) account = self.dictionary.accounts[0];
      self.direction = self.catalogData.DefaultPaymentDirection;
      self.operation = self.catalogData.DefaultPaymentOperation;
      self.category = type ? type.category : 0;
      self.type = self.catalogData.DefaultPaymentType;
      self.cash = cash ? cash.value : '';
      self.account = account ? account.value : '';
      self.regularAdd([{value: self.$props.id}]).then(resolve, reject);
    });
  }

  initEdit() {
    const self = this;
    return new Promise((resolve, reject) => {
      axios
        .get(`/tourclient/payment/getPayment?ID=${self.id}&_=${new Date().getTime()}`)
        .then(async ({data}) => {
          if (data.ResultQueryInfo.HasError) {
            self.none = true;
            self.loading = false;
            return reject();
          }
          const pay = data.Payment;
          const type = self.dictionary.types.find(i => i.id === pay.PaymentTypeId);
          self._form.certificate = pay.CertificateId;
          self._form.certificateName = pay.CertificateNumber;
          self._form.direction = pay.Direction - 1;
          self._form.operation = pay.PaymentOperationID;
          self._form.rateArticle = pay.RateArticleId;
          self._form.category = type ? type.category : 0;
          self._form.type = pay.PaymentTypeId;
          self._form.cash = pay.CashId;
          self._form.account = pay.PaymentAccountId;
          self._form.accountNumber = pay.AccountNumber;
          self._form.contragentType = pay.ContragentType;
          self._form.contragent = pay.ContragentID;
          self._form.contragentName = pay.ContragentName;
          self._form.legal = pay.PartnerLegalEntityId ? pay.PartnerLegalEntityId : '';
          self._form.legalName = pay.PartnerLegalEntityName ? pay.PartnerLegalEntityName : '';
          self._form.legalName = pay.PartnerLegalEntityName ? pay.PartnerLegalEntityName : '';
          self._form.sum = Math.abs(pay.Sum);
          self._form.commission = pay.BankCommission;
          self._form.currency = pay.CurrencyId;
          self._form.reason = pay.PaymentFor ? pay.PaymentFor : '';
          self._form.comment = pay.Comment ? pay.Comment : '';
          self._form.document = pay.DocumentNumber;
          self._form.date = pay.PaymentDate.Serialized;
          self._text.createManager = pay.Manager;
          self._text.createSystem = pay.PaySystemType;
          self._text.createDate = pay.CreateDate ? pay.CreateDate.Serialized : '';
          self._form.nds = pay.SumVat ? pay.SumVat : 0;
          self._form.showNds = !!pay.SumVat;
          self.additionalValues = data.AdditionalValues ? data.AdditionalValues : [];


          if (pay.PaymentDetails.length) {
            await Promise.all[pay.PaymentDetails.map(i => self.agreement.edit(i))]
          }
          this.setFilters();
          if (pay.RegularPayments.length) {
            await Promise.all[pay.RegularPayments.map(i => self.regular.edit(i))]
          }
          self.setFilters();
          self.files.get();
          resolve();
        }, (e)=>{
          self.none = true;
          self.loading = false;
        })
    });
  }

  initBonus() {
    const self = this;
    return new Promise((resolve, reject) => {
      const operation = self.dictionary.operations.find(i => i.bonuses);
      if (!operation) {
        self.initAgreement();
        notification.warning('Отсутствует платёжная операция с бонусным типом. Оплата бонусами невозможна.');
        return reject('Отсутствует платёжная операция с бонусным типом. Оплата бонусами невозможна.');

      }
      self.direction = operation.direction;
      self.operation = operation.value;
      self.date = new Date().toStringRu();
      self
        .agreementAdd(self.$props.id)
        .then(agreement => {
          self.sum = agreement.bonus;
          resolve(self);
        }, reject)
    });
  }

  regularAdd(list) {
    return this.regular.add(list);
  }

  regularRemove(item) {
    this.regular.remove(item);
  }

  submit() {
    const self = this;
    return new Promise((resolve, reject) => {
      if (self.sum < self.agreement.value) {
        reject('Сумма к оплате не может быть меньше суммы оплаты по заявкам');
        return
      }
      self.loading = true;

      // лютый костыль для представления значений списков доп. описаний
      // впрочем, ничего необычного - у нас ведь все доп. описания являются костылями
      let addValues = JSON.parse(JSON.stringify(self.additionalValues));
      addValues.forEach(addVal => {
        if (addVal.AdditionalValueTypeId == 4){
          addVal.SelectedOptions = [ addVal.Value ];
        }
        if (addVal.AdditionalValueTypeId == 5 && addVal.SelectedOptions){
          let splittedValues = "";
          addVal.SelectedOptions.forEach(function (val) {
            if (splittedValues.length > 0) {
              splittedValues += ',';
            }
            splittedValues += val;
          });
          addVal.Value = splittedValues;
        }
      });
      axios
        .post(`/tourclient/payment/${self.id ? 'update' : 'add'}`, `request=${encodeURIComponent(JSON.stringify({
          PaymentItem: self.data,
          ...(
            (this.addCashCheck)?{
              OnlineCashId: this.OnlineCashId,
              BillProvideTypeId: this.BillProvideTypeId,
            }:{}
          ),
          AdditionalValues: addValues,
        }))}`)
        .then(async ({data}) => {
          if (data.ResultQueryInfo && data.ResultQueryInfo.HasError) {
            data.error = data.ResultQueryInfo.UserMessages;
            if (!(data.Id > 0)) {
              reject(data.ResultQueryInfo.UserMessages);
              return;
            }
          }
          const saveFiles = !self._form.id;
          self._form.id = data.Id;
          if (saveFiles) {
            await self.files.save(data.Id);
          }
          if (this.addCashCheck && !data.Id) {
            await self.statusCheck(this.OnlineCashId, data.FiskalOperationId);
          }
          resolve(data);
        }, reject)
        .finally(() => {
          self.loading = false;
        })
    });
  }

  statusCheck(cash, uuid){
    const self = this;
    return new Promise((resolve, reject) => {
      axios
        .get(`/tourclient/api/onlinecash/document/${cash}/${uuid}`)
        .then(({data})=>{
          switch (data.OperationStatusId) {
            case 1:
              setTimeout(()=>{
                self.statusCheck(cash, uuid).then(resolve, reject);
              }, 1000);
              return;
            case 2:
              window.app.$notify.success({
                message: `Чек успешно ${self.BillProvideTypeId === 2 || self.BillProvideTypeId === 3 ? 'отправлен' : 'распечатан'}`,
              });
              break;
            case 3:
              window.app.$notify.warning({
                message: data.ResultQueryInfo.UserMessages,
              });
              break;
          }
          resolve();
        })
        .catch(()=>{
          window.app.$notify.warning({
            message: 'Ошибка в проведении чека',
          });
          resolve();
        });
    });
  }

  get loading() {
    return super.loading || this.regular.loading;
  }

  set loading(value) {
    this._loading = value;
  }

  get certificate() {
    return this._form.certificate;
  }

  set certificate(value) {
    this._form.certificate = value;
  }

  get certificateName() {
    return this._form.certificateName;
  }

  set certificateName(value) {
    this._form.certificateName = value;
  }

  get regulars() {
    return this.regular._items;
  }

  set regulars(value) {
    this.regular._items = value;
  }


  get document() {
    return this._form.document;
  }

  set document(value) {
    this._form.document = value;
  }

  get date() {
    return this._form.date;
  }

  set date(value) {
    this._form.date = value;
  }

  get direction() {
    return super.direction;
  }

  set direction(value) {
    super.direction = value;
    if (this.catalogData) {
      this.document = value ? this.catalogData.OutcomePaymentNumber : this.catalogData.IncomePaymentNumber;
    }
  }

  get createManager() {
    return this._text.createManager;
  }

  get createSystem() {
    return this._text.createSystem;
  }

  get createDate() {
    return this._text.createDate;
  }

  get nds() {
    return this._form.nds;
  }

  set nds(value) {
    this._form.nds = value;
  }

  get showNds() {
    return this._form.showNds;
  }

  set showNds(value) {
    this._form.showNds = value;
  }

  get OnlineCashId() {
    return this._form.OnlineCashId;
  }

  set OnlineCashId(value) {
    this._form.OnlineCashId = value;
  }

  get BillProvideTypeId() {
    return this._form.BillProvideTypeId;
  }

  set BillProvideTypeId(value) {
    this._form.BillProvideTypeId = value;
  }

  get data() {
    debugger;
    const data = {};
    if (this.id) data.Id = this.id;
    data.PaymentDirection = this.direction;
    data.Direction = this.direction + 1;
    data.PaymentOperationID = this.operation;
    data.PaymentTypeId = this.type;
    data.ContragentType = this.contragentType;
    data.ContragentID = this.contragent;
    data.Sum = this.sum;
    data.BankCommission = this.commission;
    data.CurrencyId = this.currency;
    data.Comment = this.comment;
    if (this.direction === 1) data.RateArticleId = this.rateArticle;
    if ([2, 3, 6, 7].indexOf(this.contragentType >= 0)) data.PartnerLegalEntityId = this.legal;
    if (this.category === 0) data.CashId = this.cash;
    if (this.category === 1) data.PaymentAccountId = this.account;
    if (this.operationAgreement) {
      data.AccountNumber = this.accountNumber;
      data.PaymentDetails = (this.agreements.map(i => i.ajaxData)).filter(i => i);
    }
    data.PaymentFor = this.reason;
    data.DocumentNumber = this.document;
    data.PaymentDate = {"Serialized": this.date, "Format": "dd.MM.yyyy"};
    if (this.certificate) data.CertificateId = this.certificate;
    data.RegularPayments = this.regulars.map(i => ({
      RegularPaymentId: i.value,
      Spread: i.sum,
    }));
    data.SumVat = this.nds;
    return data;
  }
};
